import React from "react";
import NavBar from "../../Components/NavBar";
import Footer from "../../Components/Footer";
import UnavailablePage from "../../Components/Temporary-Components/UnavailablePage"


const B2BMarket = () => {
  return (
    <>
      <NavBar/>
      <div className="pages">

<UnavailablePage/>

      </div>
           <Footer/>

    </>
  );
};
export default B2BMarket;